let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dBkN1")).then(() => parcelRequire('eS81C'));